export const MENTION_REGEX = /@[^[]+\[(?:email:|user_id:|group_id:)[^\]]+\]/gi;
